// @flow
import shortId from 'shortid';

export const cleanupId = (text: ?string) =>
  text ? `${text}`.replace(/[^a-zA-Z0-9]/g, '').toLocaleLowerCase() : '';

export const generateUniqueId = (list: Array<?string>, prefix?: string = '') => {
  if (list.length) {
    const id = list
      .filter(Boolean)
      .map(cleanupId)
      .filter(Boolean)
      .join('-');
    if (id) {
      return `${prefix}${id}`.toLocaleLowerCase();
    }
  }

  // should not occurs, it breaks the server/client reconciliation
  return `${prefix}${shortId.generate()}`.toLocaleLowerCase();
};
